import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormData } from '../aeo-approval/aeo-approval.component';


@Component({
  selector: 'cargoes-action-comments',
  templateUrl: './action-comments.component.html',
})
export class ActionCommentsComponent implements OnInit {

  @Input() public defaultFormData!: string;
  @Output() public submitedFormData = new EventEmitter<FormData>();
  public actions: string[] = [];
  public actionCommentsGroup!: FormGroup;
  public listSelectedAction = [];

  // eslint-disable-next-line no-empty-function
  constructor(private formBuilder: FormBuilder) {}

  ngOnInit():void {
    this.onLoad(this.defaultFormData);
  }

  /**
   * A - Approval, R - Reject, M - More Info Request
   * @param defaults | ARMC
   */
  onLoad(data: string):void {
    this.actions = this.prepareActions(data);
    this.actionCommentsGroup = this.formBuilder.group({
      selectedAction: ['', [Validators.required]],
      comments: '',
    });
  }

  prepareActions(data: string): string[]{
    const actions: string[] = [];
    data.split('').forEach((d)=>{
      if(d.toLowerCase() === 'a')
        actions.push('Approved');
      if(d.toLowerCase() === 'r')
        actions.push('Rejected');
      if(d.toLowerCase() === 'm')
        actions.push('More Info Request');
    });
    return actions;
  }

  onSubmit():void {
    const action =  (this.actionCommentsGroup.value.selectedAction ==='More Info Request' ) ? 'MoreInfo': this.actionCommentsGroup.value.selectedAction;
    const formData = {
      'variables':{
        'action':{'value': action},
        'comments': {'value': this.actionCommentsGroup.value.comments}
      }
    };
    this.submitedFormData.emit(formData);
    this.actionCommentsGroup.patchValue({selectedAction:'',comments:''});
    this.listSelectedAction = [];
  }
}
